import { AUTOMATION_ACTION } from 'src/app/enum/constants';
import {
  PlannerActionsDropdownItem,
  PlannerItem,
} from '../../../../../components/layout/stacked-sidebar/components/planner-v2/planner-v2.interface';

export interface AutomationPlannerItem extends PlannerItem {
  planner_action?: string;
  error_code?: string;
}

export enum PLANNER_AUTOMATION_ACTION {
  SEND_MESSAGE = AUTOMATION_ACTION.SEND_MESSAGE,
  GENERATE_AI = AUTOMATION_ACTION.GENERATE_AI,
  MOVE_DEAL = AUTOMATION_ACTION.MOVE_DEAL,
  SEND_TELEGRAM_NOTIFICATION = AUTOMATION_ACTION.SEND_TELEGRAM_NOTIFICATION,
  CLOSE_CHAT = AUTOMATION_ACTION.CLOSE_CHAT,
}

export const PLANNER_AUTOMATION_ACTIONS_REGISTRY: Record<PLANNER_AUTOMATION_ACTION, PlannerActionsDropdownItem> = {
  [PLANNER_AUTOMATION_ACTION.SEND_MESSAGE]: {
    name: 'automation_action.send_message',
    value: PLANNER_AUTOMATION_ACTION.SEND_MESSAGE,
  },
  [PLANNER_AUTOMATION_ACTION.GENERATE_AI]: {
    name: 'automation_action.generate_ai',
    value: PLANNER_AUTOMATION_ACTION.GENERATE_AI,
  },
  [PLANNER_AUTOMATION_ACTION.MOVE_DEAL]: {
    name: 'automation_action.move_deal',
    value: PLANNER_AUTOMATION_ACTION.MOVE_DEAL,
  },
  [PLANNER_AUTOMATION_ACTION.SEND_TELEGRAM_NOTIFICATION]: {
    name: 'automation_action.send_telegram_notification',
    value: PLANNER_AUTOMATION_ACTION.SEND_TELEGRAM_NOTIFICATION,
  },
  [PLANNER_AUTOMATION_ACTION.CLOSE_CHAT]: {
    name: 'automation_action.close_chat',
    value: PLANNER_AUTOMATION_ACTION.CLOSE_CHAT,
  },
};
